import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";

const HRDRedirectContainer = () => {
  const { t } = useTranslation();

  useEffect(() => {
    document.title = t("customHRD.tabs.redirecting");
  }, [t]);

  return <div className="hrd-redirect-page"></div>;
};

export default HRDRedirectContainer;